import React from 'react';
import './BookmarksPanel.css';

// Scroll to an anchor ID with offset to account for fixed navbar
function scrollToSection(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const navHeight = document.querySelector('.navbar')?.offsetHeight || 70;
  const y = el.getBoundingClientRect().top + window.scrollY - navHeight - 16;
  window.scrollTo({ top: y, behavior: 'smooth' });
}

function Navbar({ theme = 'dark', onToggleTheme, soundMuted = false, onToggleSound, bookmarkCount = 0, onOpenBookmarks }) {
  const isDark = theme === 'dark';
  return (
    <nav className="navbar">
      <div className="navbar-logo">FashionAI</div>
      <div className="navbar-right">
        <ul className="navbar-links">
          <li>
            <a
              href="#create"
              onClick={(e) => { e.preventDefault(); scrollToSection('create'); }}
            >
              Create
            </a>
          </li>
          <li>
            <a
              href="#gallery"
              onClick={(e) => { e.preventDefault(); scrollToSection('gallery'); }}
            >
              Gallery
            </a>
          </li>
        </ul>

        {/* Bookmarks button */}
        {onOpenBookmarks && (
          <button
            className="bm-nav-btn"
            onClick={onOpenBookmarks}
            aria-label={`My Bookmarks${bookmarkCount ? ` (${bookmarkCount})` : ''}`}
            title="My Bookmarks"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill={bookmarkCount > 0 ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>
            </svg>
            {bookmarkCount > 0 && (
              <span className="bm-nav-badge">{bookmarkCount > 99 ? '99+' : bookmarkCount}</span>
            )}
          </button>
        )}

        {/* Sound mute toggle */}
        {onToggleSound && (
          <button
            className="theme-toggle sound-toggle"
            onClick={onToggleSound}
            aria-label={soundMuted ? 'Unmute sounds' : 'Mute sounds'}
            title={soundMuted ? 'Unmute sounds' : 'Mute sounds'}
          >
            {soundMuted ? (
              // Muted speaker icon
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/>
                <line x1="23" y1="9" x2="17" y2="15"/>
                <line x1="17" y1="9" x2="23" y2="15"/>
              </svg>
            ) : (
              // Speaker with waves icon
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/>
                <path d="M15.54 8.46a5 5 0 0 1 0 7.07"/>
                <path d="M19.07 4.93a10 10 0 0 1 0 14.14"/>
              </svg>
            )}
          </button>
        )}

        {/* Theme toggle button */}
        <button
          className="theme-toggle"
          onClick={onToggleTheme}
          aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
          title={isDark ? 'Light mode' : 'Dark mode'}
        >
          {isDark ? (
            // Sun icon
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="5"/>
              <line x1="12" y1="1" x2="12" y2="3"/>
              <line x1="12" y1="21" x2="12" y2="23"/>
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
              <line x1="1" y1="12" x2="3" y2="12"/>
              <line x1="21" y1="12" x2="23" y2="12"/>
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
            </svg>
          ) : (
            // Moon icon
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
            </svg>
          )}
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
